import React, {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {ComposableMap, Geographies, Geography} from "react-simple-maps";
import {Tooltip} from "react-tooltip";
import {scaleLinear} from "d3-scale";

import APIClient from "../../client";
import config from "../../config.js";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function MapChart(props) {
    const [mapData, setMapData] = useState({});
    const [error, setError] = useState(null)
    const [content, setContent] = useState({});

    const navigate = useNavigate();

    const colorScale = scaleLinear()
        .domain([0.29, 0.68])
        .range(["#0074E0", "#0074E0"]);


    useEffect(() => {

    }, []);

    const handleClick = geo => () => {
        const opportunity = props.opportunitydata.findIndex(x => x.country === geo.name);

        if (opportunity > -1) {
            const opp = props.opportunitydata?.[opportunity]

            navigate("/opportunity", {
                state: [{
                    "partner": opp.partner,
                    "funder": opp.funder,
                    "country": opp.country,
                    "currency": opp.currency
                }]
            });

        }


    };

    const screenSize = (window.innerWidth >= 768);


    return (
        <>
            <ComposableMap
                projection="geoConicConformal"
                projectionConfig={{
                    rotate: [-20.0, -0.0, 0],
                    center: [1, -15],
                    scale: 280,
                }}
            >
                <Geographies geography="/Africa0.json">
                    {({geographies}) =>
                        geographies.map((geo) => {
                            const d = props.mapdata.find((s) => s.id === geo.id);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={handleClick(geo.properties)}
                                    stroke="#bebebe"
                                    fill={d ? colorScale(d["value"]) : "#EEEEEE"}
                                    onMouseEnter={() => {
                                        setContent(`${geo.id}`);
                                    }}
                                    onMouseLeave={() => {
                                        setContent("");
                                    }}
                                />
                            );
                        })
                    }
                </Geographies>
            </ComposableMap>
            <Tooltip>{content}</Tooltip>


        </>
    );


}